import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  id: "modal_add_manufacturer",
  tabindex: "-1",
  "aria-hidden": "true",
  "data-bs-backdrop": "static",
  "data-bs-keyboard": "false"
}
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered mw-650px" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = {
  class: "modal-header",
  id: "kt_modal_new_address_header"
}
const _hoisted_5 = /*#__PURE__*/_createVNode("div", {
  class: "btn btn-sm btn-icon",
  "data-bs-dismiss": "modal"
}, [
  /*#__PURE__*/_createVNode("span", { class: "svg-icon svg-icon-1" }, [
    /*#__PURE__*/_createVNode("i", { class: "fas fa-times" })
  ])
], -1)
const _hoisted_6 = { class: "modal-body py-10 px-lg-17" }
const _hoisted_7 = { class: "scroll-y me-n7 pe-7" }
const _hoisted_8 = {
  key: 0,
  class: "col-md-12 upload-image-col"
}
const _hoisted_9 = { class: "upload-image-box" }
const _hoisted_10 = { class: "upload-box" }
const _hoisted_11 = { class: "add-image" }
const _hoisted_12 = /*#__PURE__*/_createVNode("div", { class: "icon" }, [
  /*#__PURE__*/_createVNode("i", { class: "fas fa-camera-retro" })
], -1)
const _hoisted_13 = {
  key: 1,
  class: "col-md-4 mt-10"
}
const _hoisted_14 = { class: "hover-effect" }
const _hoisted_15 = { class: "image-heading" }
const _hoisted_16 = /*#__PURE__*/_createTextVNode("  ")
const _hoisted_17 = /*#__PURE__*/_createVNode("div", { style: {"clear":"both"} }, null, -1)
const _hoisted_18 = { class: "modal-footer flex-center" }
const _hoisted_19 = {
  type: "reset",
  class: "btn btn-white me-3",
  "data-bs-dismiss": "modal"
}
const _hoisted_20 = { class: "indicator-label" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InnerLoader = _resolveComponent("InnerLoader")!
  const _component_Input = _resolveComponent("Input")!
  const _component_Image = _resolveComponent("Image")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_InnerLoader, {
      loading: _ctx.loading,
      innerLoading: true
    }, null, 8, ["loading"]),
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode(_component_el_form, {
          model: _ctx.manufacturerData,
          ref: "addManufacturerForm"
        }, {
          default: _withCtx(() => [
            _createVNode("div", _hoisted_4, [
              _createVNode("h2", null, _toDisplayString(`${_ctx.$t('message.ADD')} ${_ctx.$t('message.MANUFACTURER')}`), 1),
              _hoisted_5
            ]),
            _createVNode("div", _hoisted_6, [
              _createVNode("div", _hoisted_7, [
                _createVNode(_component_Input, {
                  type: "text",
                  name: "name",
                  label: `${_ctx.$t('message.NAME')}`,
                  placeholder: `${_ctx.$t('message.ENTER')} ${_ctx.$t('message.NAME')}`,
                  "onUpdate:name": _cache[1] || (_cache[1] = ($event: any) => (_ctx.manufacturerData.name = $event)),
                  target: "name",
                  required: true,
                  value: _ctx.manufacturerData.name
                }, null, 8, ["label", "placeholder", "name", "value"]),
                _createVNode(_component_Input, {
                  type: "textarea",
                  name: "description",
                  label: `${_ctx.$t('message.DESCRIPTION')}`,
                  placeholder: `${_ctx.$t('message.ENTER')} ${_ctx.$t('message.DESCRIPTION')}`,
                  description: _ctx.manufacturerData.description,
                  "onUpdate:description": _cache[2] || (_cache[2] = ($event: any) => (_ctx.manufacturerData.description = $event)),
                  target: "description",
                  required: true,
                  value: _ctx.manufacturerData.description
                }, null, 8, ["label", "placeholder", "description", "value"])
              ]),
              (_ctx.previewImage.length == 0)
                ? (_openBlock(), _createBlock("div", _hoisted_8, [
                    _createVNode("div", _hoisted_9, [
                      _createVNode("div", _hoisted_10, [
                        _createVNode("div", _hoisted_11, [
                          _createVNode("input", {
                            type: "file",
                            class: "upload-btn",
                            accept: "image/png, image/jpg, image/jpeg",
                            onChange: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.handleChange && _ctx.handleChange(...args)))
                          }, null, 32),
                          _hoisted_12,
                          _createVNode("strong", null, _toDisplayString(_ctx.$t('message.UPLOAD_IMAGES')), 1),
                          _createVNode("span", null, "JPG, GIF " + _toDisplayString(_ctx.$t('message.OR')) + " PNG " + _toDisplayString(_ctx.$t('message.FORMAT')), 1)
                        ])
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.previewImage.length != 0)
                ? (_openBlock(), _createBlock("div", _hoisted_13, [
                    _createVNode("div", _hoisted_14, [
                      _createVNode("img", {
                        src: _ctx.previewImage[0].src,
                        alt: "uploaded Images",
                        class: "image-thumbnail",
                        style: {}
                      }, null, 8, ["src"]),
                      _createVNode("span", _hoisted_15, [
                        _createVNode("i", {
                          class: "fas fa-search",
                          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.showMedia(0)))
                        }),
                        _hoisted_16,
                        _createVNode("i", {
                          class: "fas fa-trash-alt",
                          onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.removeMedia(0, _ctx.previewImage[0].id)))
                        })
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              _hoisted_17,
              _createVNode(_component_Image)
            ]),
            _createVNode("div", _hoisted_18, [
              _createVNode("button", _hoisted_19, _toDisplayString(_ctx.$t('message.CANCEL')), 1),
              _createVNode("button", {
                type: "button",
                class: "btn btn-custom",
                onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.submitHandlerForm()))
              }, [
                _createVNode("span", _hoisted_20, _toDisplayString(_ctx.$t('message.SUBMIT')), 1)
              ])
            ])
          ]),
          _: 1
        }, 8, ["model"])
      ])
    ])
  ]))
}